(() => {
  const els = Array.from(document.querySelectorAll("[data-zerv-animate]"));
  if (!els.length) return;

  // Optional: allow per-element delay using CSS var (--zerv-delay)
  // Default stagger within each section
  const setStagger = () => {
    const groups = new Map();
    els.forEach((el) => {
      const key = el.closest("section") || document.body;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(el);
    });

    groups.forEach((groupEls) => {
      groupEls.forEach((el, i) => {
        if (!el.style.getPropertyValue("--zerv-delay")) {
          el.style.setProperty("--zerv-delay", `${i * 80}ms`);
        }
      });
    });
  };

  setStagger();

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("zerv-in");
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -10% 0px" }
  );

  els.forEach((el) => io.observe(el));

  // Support Shopify theme editor live refreshes (when sections reload)
  document.addEventListener("shopify:section:load", () => {
    const fresh = Array.from(document.querySelectorAll("[data-zerv-animate]:not(.zerv-in)"));
    fresh.forEach((el) => io.observe(el));
  });
})();
